import BugOutline from './images/outline/bug.svg';
import ConfusionOutline from './images/outline/confusion.svg';
import ConversionOutline from './images/outline/conversion.svg';
import FrustrationOutline from './images/outline/frustration.svg';
import IssueOutline from './images/outline/issue.svg';
import SuccessOutline from './images/outline/success.svg';

import BugPlain from './images/plain/bug.svg';
import ConfusionPlain from './images/plain/confusion.svg';
import ConversionPlain from './images/plain/conversion.svg';
import FrustrationPlain from './images/plain/frustration.svg';
import IssuePlain from './images/plain/issue.svg';
import SuccessPlain from './images/plain/success.svg';

import { LegacyContext } from './context/global-context';

export { AppliedLabels } from './components/AppliedLabels';

export { LabelsEditor } from './components/LabelsEditor';

export { Overflow } from './components/Overflow';

export { Overflow as OverflowV2 } from './components/V2/Overflow';

export { LabelCreator } from './components/V2/LabelCreator/LabelCreator';

export { Label } from './components/Label';

export { Label as LabelV2 } from './components/V2/Label';

export { AsyncIcon } from './components/AsyncIcon';

export { DEFAULT_LABEL_ICONS } from './constants/label-icons';

export { useAvailableLabels } from './hooks/use-available-labels';

export { useCreateLabel } from './hooks/use-create-label';

export { mapLabelDtoToModel, mapLabelIdsModelToDto } from './domains/mapper';

export type { Label as LabelDto } from './domains/dto';

export type { Label as LabelModel, IconName as IconNameModel } from './domains/model';

export { addCustomLabel } from './domains/api';

export type { GetAllLabelResponse } from './domains/api';

export { mapLabelsToMultiSelectOptions } from './utils/map-labels-to-multi-select-options';

export const LabelsContextProvider = LegacyContext.Provider;

export const reactionsSvgOutline = {
  bug: BugOutline,
  confusion: ConfusionOutline,
  conversion: ConversionOutline,
  frustration: FrustrationOutline,
  issue: IssueOutline,
  success: SuccessOutline,
};

export const reactionsSvgPlain = {
  bug: BugPlain,
  confusion: ConfusionPlain,
  conversion: ConversionPlain,
  frustration: FrustrationPlain,
  issue: IssuePlain,
  success: SuccessPlain,
};
